export const bus = {
  title: "Live Bus Tracking",
  description: "Enable real-time bus tracking using the UK Bus Open Data Service (BODS)",
  enabled: "Enable Bus Pins",
  routeSelection: "BODS Route",
  routesSelection: "BODS Routes",
  routeHelp: "Select the BODS GTFS route_id for this service (Outer Circle 11A is 128663)",
  routesHelp: "Select one or more BODS GTFS route_ids for the services this pin tracks",
  updateInterval: "Update Interval",
  updateIntervalHelp: "How often the bus location updates (5-30 seconds)",
  calloutText: "Custom Callout Text",
  calloutTextHelp: "Text shown when listeners tap the bus pin",
  busIcon: "Bus Icon",
  busIconHelp: "Custom icon for the bus pin (optional)",
  busName: "Bus Name",
  busNameHelp: "Display name for the bus (optional)",
  busDescription: "Bus Description",
  busDescriptionHelp: "Description for the bus (optional)",
  validation: {
    routeRequired: "Route ID is required when bus tracking is enabled",
    intervalTooLow: "Update interval must be at least 5 seconds",
    intervalTooHigh: "Update interval must be no more than 30 seconds"
  },
  status: {
    active: "Active: Bus is being tracked",
    noData: "No Data: No buses found on this route",
    error: "Error: API connection issues"
  },
  help: {
    title: "About Bus Pins",
    description: "Bus pins track real buses in real-time and can be collected when reached. They work just like regular pins but with live location updates.",
    routeCode: "BODS route ID: GTFS route_id from the national bus open data feed (not the number on the bus)",
    updateFrequency: "Update Interval: How often the bus location updates (5-30 seconds)",
    collection: "Bus pins can be collected when listeners reach the bus location"
  }
}
